import Home from './components/Home/index.vue'
import Login from './components/Login/index.vue'
import Logout from './components/Logout/index.vue'
import Todo from './components/Todo/index.vue'
import Todoitems from './components/Todo/items.vue'
import Dashboard from './components/Dashboard/index.vue'
import AddEvent from './components/Event/index.vue'
import EditEvent from './components/Event/edit.vue'
import notfound from './components/404/index.vue'
import PanelRightPage from './components/Pannel/right.vue'
import store from './Store/store';

const authGuard = {
    beforeEnter: (to, from, next) => {

        const redirect = () => {
            if( store.state.admin.token ){
                if(to.path === '/login'){
                    next('/todo')
                } else {
                    next()
                }
            } else {
                if(to.path === '/login' ){
                    next()
                } else {
                    next('/')
                }
            }
        }

        if( store.state.admin.refreshLoading ){
            store.watch((state, getters)=> getters['admin/refreshLoading'],()=>{
                redirect();
            })
        } else {
            redirect();
        }

    }
}



export default [
    { path: '/login',component: Login, ...authGuard},
    { path: '/', component: Home },
    { 
        path: '/todo', 
        component: Todo, 
        options: {
            reloadCurrent: true
        },
        beforeEnter: function(to, from, resolve) {
            if (from.path != '/editevent' && !from.path.includes('/todo/')) {
                localStorage.removeItem('edit');
            }
            resolve();
        } 
    },
    { 
        path: '/todo/:groupID', 
        component: Todoitems
    },
    { path: '/dashboard',component: Dashboard},
    { path: '/addevent',component: AddEvent},
    { path: '/editevent',component: EditEvent},
    { path: '/logout', component: Logout },
    {
        path: '/panel-right/',
        component: PanelRightPage
    },
    {
        path: '(.*)',
        component: notfound,
    },
];
